// extracted by mini-css-extract-plugin
export default {"root":"ExerciseStaticsButtons_root__N2eLZ","count":"ExerciseStaticsButtons_count__9ICNc","button":"ExerciseStaticsButtons_button__QZ9AG"};